import React from "react";
import "./css/AboutUs.css";
import headerBg from "./assets/picOne.png"; // reuse or replace with a relevant image

const ManagementSystemsAuditor = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Management Systems Auditor</h1>
          <p className="subtitle">
            The Malawi Bureau of Standards (MBS) provides training and certification for Management Systems Auditors under its Industrial Research and Training division.
          </p>
          <p className="subtitle">
            Management Systems Auditors play a critical role in assessing organizational compliance with national and international standards, ensuring continuous improvement, and promoting quality management practices.
          </p>
        </div>
      </section>

      {/* === Roles of a Management Systems Auditor Section === */}
      <section className="intro-section">
        <h2 className="section-title">Roles and Responsibilities</h2>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Conduct audits of management systems such as ISO 9001, ISO 14001, and ISO 45001</li>
              <li>Assess organizational compliance with national and international standards</li>
              <li>Identify non-conformities and recommend corrective actions</li>
              <li>Verify implementation of management system processes</li>
              <li>Provide technical guidance and consultancy to organizations</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Prepare audit reports and document findings accurately</li>
              <li>Support certification processes by evaluating readiness for certification</li>
              <li>Monitor continuous improvement and effectiveness of management systems</li>
              <li>Participate in training programs to enhance auditing skills</li>
              <li>Ensure impartiality, integrity, and professionalism in all audit activities</li>
            </ul>
          </div>
        </div>
      </section>

      {/* === Benefits of Becoming an Auditor Section === */}
      <section className="functions-section">
        <h2 className="section-title">Benefits of Management Systems Auditors</h2>
        <p>
          Becoming a certified Management Systems Auditor equips professionals with the skills to evaluate and improve organizational processes, enhance compliance, promote quality culture, and increase career opportunities in auditing and quality management.
        </p>
      </section>

      {/* === Contact Section === */}
      <section className="functions-section">
        <h2 className="section-title">Contact for Auditor Training</h2>
        <p>
          For inquiries, enrollment, or more information about Management Systems Auditor training and certification, please contact the Industrial Research and Training team at MBS.
        </p>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Email: <a href="mailto:training@mbs.mw">training@mbs.mw</a></li>
              <li>Phone: +265 (0) 1 789 888</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Office: Malawi Bureau of Standards, P.O. Box 946, Blantyre, Malawi</li>
              <li>Website: <a href="https://www.mbs.mw">www.mbs.mw</a></li>
            </ul>
          </div>
        </div>
        <p className="subtitle">
          Management Systems Auditors contribute to organizational excellence by ensuring compliance with standards, promoting best practices, and enhancing quality and efficiency in Malawi.
        </p>
      </section>

      <br /><br />
    </div>
  );
};

export default ManagementSystemsAuditor;
